import React from 'react';
import { CognocracyLanding } from './pages/CognocracyLanding';
export function App() {
  return <>
      <div className="scanlines" aria-hidden="true" data-id="element-0" />
      <CognocracyLanding data-id="element-1" />
    </>;
}